import { Col, Row, Card, Divider, Typography, Space, Button } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
import { useState } from "react";
import { ScatterCharts } from "./PointColumnChart";
import LabelBarChart from "../charts/bar_chart/view/LabelBarChart";
import { DonutTable } from "./DonutTable";
import { DonutProgress } from "./DonutProgress";
import { ColorsCardList } from "../charts/colors_card/view/ColorsCardList";
import SmallTable from "../charts/small_table/view/SmallTable";
const ProtalMainPage = ({ props, prefixTitle }) => {
    //   const language = props.language;
    return (
        <Row
            gutter={[10, 20]}
            justify="space-around"
            style={{ padding: "20px" }}
        >
            <Col span={24}>
                <Row gutter={[16, 16]}>
                    <Col lg={8} md={24} sm={24} xs={24}>
                        <Card>
                            <Row span={[32, 32]}>
                                <Col span={24}>
                                    <Row>
                                        <Col span={24}>
                                            <Space>
                                                <Typography.Title
                                                    level={2}
                                                    style={{
                                                        padding: "0px",
                                                        margin: "0px",
                                                    }}
                                                >
                                                    {prefixTitle}
                                                </Typography.Title>
                                                <Button
                                                    style={{
                                                        backgroundColor: "#748BC0",
                                                        color: "#fff",
                                                    }}
                                                    //   icon={
                                                    //     <PlusCircleFilled style={{ color: "#C6CDFB" }} />
                                                    //   }
                                                    onClick={() => navigator(`/management`)}
                                                >
                                                    網站設定
                                                </Button>
                                            </Space>
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Row>
                                        <Col span={24}>
                                            <Typography.Title level={4}>選單分類</Typography.Title>
                                        </Col>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Text
                                                        style={{
                                                            color: "#EA898D",
                                                        }}
                                                    >
                                                        選單數量
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <DonutProgress
                                                colorTheams="bright_bule"
                                                DonutData={[
                                                    { name: '選單分類A', value: 10 },
                                                    { name: '選單分類B', value: 20 },
                                                    { name: '選單分類C', value: 15 },
                                                    { name: '選單分類D', value: 3 },
                                                ]}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}>
                                                        頁面使用情形統計
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <div
                                                style={{
                                                    height: "200px",
                                                }}
                                            >
                                                <LabelBarChart
                                                    XdataKey="date"
                                                    barDatas={[
                                                        {
                                                            dataKey: "未發布",
                                                            fill: "#f09a45"
                                                        },
                                                        {
                                                            dataKey: "已發布",
                                                            fill: "#add8e6"
                                                        },

                                                    ]}
                                                    barChartDatas={[
                                                        {
                                                            date: '08/25',
                                                            已發布: 32,
                                                            未發布: 18
                                                        },
                                                        {
                                                            date: '08/26',
                                                            已發布: 45,
                                                            未發布: 20
                                                        },
                                                        {
                                                            date: '08/27',
                                                            已發布: 38,
                                                            未發布: 22
                                                        },
                                                        {
                                                            date: '08/28',
                                                            已發布: 50,
                                                            未發布: 25
                                                        },
                                                        {
                                                            date: '08/29',
                                                            已發布: 42,
                                                            未發布: 15
                                                        },
                                                        {
                                                            date: '08/30',
                                                            已發布: 37,
                                                            未發布: 19
                                                        },
                                                        {
                                                            date: '08/31',
                                                            已發布: 40,
                                                            未發布: 23
                                                        }
                                                    ]}


                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}>
                                                        貼文使用情形統計
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <div
                                                style={{
                                                    height: "200px",
                                                }}
                                            >
                                                <LabelBarChart
                                                    barDatas={[
                                                        {
                                                            dataKey: "未發布",
                                                            fill: "#faed92"
                                                        },
                                                        {
                                                            dataKey: "已發布",
                                                            fill: "#53927a"
                                                        },

                                                    ]}
                                                    barChartDatas={[
                                                        {
                                                            "date": "08/25",
                                                            "已發布": 30,
                                                            "未發布": 16
                                                        },
                                                        {
                                                            "date": "08/26",
                                                            "已發布": 43,
                                                            "未發布": 19
                                                        },
                                                        {
                                                            "date": "08/27",
                                                            "已發布": 36,
                                                            "未發布": 21
                                                        },
                                                        {
                                                            "date": "08/28",
                                                            "已發布": 48,
                                                            "未發布": 23
                                                        },
                                                        {
                                                            "date": "08/29",
                                                            "已發布": 40,
                                                            "未發布": 18
                                                        },
                                                        {
                                                            "date": "08/30",
                                                            "已發布": 34,
                                                            "未發布": 20
                                                        },
                                                        {
                                                            "date": "08/31",
                                                            "已發布": 39,
                                                            "未發布": 22
                                                        }
                                                    ]
                                                    }
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                {/* <Col span={24}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}>
                                                        單位內會議
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <div
                                                style={{
                                                    height: "200px",
                                                }}
                                            >
                                                <LabelBarChart />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col> */}
                                {/* <Col span={24}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}>
                                                        今日會議列表
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <div
                                                style={{
                                                    height: "200px",
                                                }}
                                            >
                                                <SmallTable />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col> */}
                            </Row>
                        </Card>
                    </Col>
                    <Col lg={16} md={24} sm={24} xs={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Card size="small">
                                    <Row>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}>
                                                        貼文使用排行
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <DonutTable
                                                tableColumns={[
                                                    {
                                                        title: '貼文分類',
                                                        dataIndex: 'type',
                                                        key: 'type',
                                                    },
                                                    {
                                                        title: '貼文名稱',
                                                        dataIndex: 'name',
                                                        key: 'name',
                                                    },
                                                    {
                                                        title: '使用次數',
                                                        dataIndex: 'times',
                                                        key: 'times',
                                                    },
                                                ]}
                                                tableData={[

                                                    {
                                                        key: '2',
                                                        type: '娛樂',
                                                        name: '明星八卦',
                                                        times: 42,
                                                    },
                                                    {
                                                        key: '5',
                                                        type: '生活',
                                                        name: '健康生活小貼士',
                                                        times: 40,
                                                    },
                                                    {
                                                        key: '4',
                                                        type: '運動',
                                                        name: '今日比賽結果',
                                                        times: 35,
                                                    },
                                                    {
                                                        key: '1',
                                                        type: '新聞',
                                                        name: '每日快報',
                                                        times: 32,
                                                    },
                                                    {
                                                        key: '3',
                                                        type: '科技',
                                                        name: '最新科技發展',
                                                        times: 28,
                                                    },


                                                ]}
                                                DonutData={[
                                                    { name: '明星八卦', value: 42 },
                                                    { name: '健康生活小貼士', value: 40 },
                                                    { name: '今日比賽結果', value: 35 },
                                                    { name: '每日快報', value: 32 },
                                                    { name: '最新科技發展', value: 28 },
                                                ]}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col span={12}>
                                <Card size="small">
                                    <Row>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}>
                                                        問題分類統計
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button type="link">查看更多</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <DonutTable
                                                tableColumns={[
                                                    {
                                                        title: '問題分類',
                                                        dataIndex: 'category',
                                                        key: 'category',
                                                    },
                                                    {
                                                        title: '問題名稱',
                                                        dataIndex: 'name',
                                                        key: 'name',
                                                    },
                                                    {
                                                        title: '出現次數',
                                                        dataIndex: 'times',
                                                        key: 'times',
                                                    },
                                                ]}
                                                tableData={[
                                                    {
                                                        key: '1',
                                                        category: '技術問題',
                                                        name: '系統崩潰',
                                                        times: 50,
                                                    },
                                                    {
                                                        key: '2',
                                                        category: '操作問題',
                                                        name: '無法登入',
                                                        times: 45,
                                                    },
                                                    {
                                                        key: '3',
                                                        category: '服務問題',
                                                        name: '回覆延遲',
                                                        times: 40,
                                                    },
                                                    {
                                                        key: '4',
                                                        category: '付款問題',
                                                        name: '付款失敗',
                                                        times: 35,
                                                    },
                                                    {
                                                        key: '5',
                                                        category: '其他問題',
                                                        name: '功能建議',
                                                        times: 30,
                                                    },

                                                ]}
                                                DonutData={[
                                                    { name: '系統崩潰', value: 50 },
                                                    { name: '無法登入', value: 45 },
                                                    { name: '回覆延遲', value: 40 },
                                                    { name: '付款失敗', value: 35 },
                                                    { name: '功能建議', value: 30 },
                                                ]}

                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col span={24}>
                                <Card size="small">
                                    <Row>
                                        <Col span={24}>
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Typography.Title level={4}>
                                                                貼文觀看人次
                                                            </Typography.Title>
                                                        </Col>
                                                        <Col>
                                                            <Button type="link">查看更多</Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <ColorsCardList
                                                                rowContentFontCount={2}
                                                                rowMoreInfoFontCount={4}
                                                                cardListTitle="娛樂"
                                                                cardDatas={[
                                                                    {
                                                                        cardContent: "明星動態",
                                                                        moreInfo: "21觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "科技趨勢",
                                                                        moreInfo: "21觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "健康飲食",
                                                                        moreInfo: "20觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "熱門新聞",
                                                                        moreInfo: "10觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "電影評論",
                                                                        moreInfo: "8觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "音樂新訊",
                                                                        moreInfo: "7觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "影視劇集",
                                                                        moreInfo: "6觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "流行趨勢",
                                                                        moreInfo: "5觀看",
                                                                    },
                                                                ]}

                                                            />
                                                        </Col>
                                                        <Col span={24}>
                                                            <ColorsCardList
                                                                leftColor="#D9F8FF"
                                                                rightColor="#E5FFE3"
                                                                rowContentFontCount={2}
                                                                rowMoreInfoFontCount={4}
                                                                cardListTitle="科技"
                                                                cardDatas={[
                                                                    {
                                                                        cardContent: "人工智慧",
                                                                        moreInfo: "30觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "量子電腦",
                                                                        moreInfo: "25觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "5G技術",
                                                                        moreInfo: "18觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "科技新品",
                                                                        moreInfo: "12觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "智能穿戴",
                                                                        moreInfo: "10觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "機器學習",
                                                                        moreInfo: "8觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "區塊鏈",
                                                                        moreInfo: "7觀看",
                                                                    },
                                                                    {
                                                                        cardContent: "虛擬實境",
                                                                        moreInfo: "5觀看",
                                                                    },
                                                                ]}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>
                                </Card>
                            </Col>
                            <Col span={24}>
                                <Card size="small">
                                    <Row>
                                        <Col span={24}>
                                            <ScatterCharts
                                                series={[
                                                    {
                                                        name: '查詢網站瀏覽人次',
                                                        data: [
                                                            [new Date(2024, 1, 3, 8, 10).getTime(), 210],
                                                            [new Date(2024, 1, 3 ,9 ,10).getTime(), 332],
                                                            [new Date(2024, 1, 3 ,10,10).getTime(), 232],
                                                            [new Date(2024, 1, 3 ,11,10).getTime(), 442],
                                                            [new Date(2024, 1, 3 ,12,10).getTime(), 201],
                                                            [new Date(2024, 1, 3 ,13,10).getTime(), 201],
                                                            [new Date(2024, 1, 3 ,14,10).getTime(), 330],
                                                            [new Date(2024, 1, 3 ,15,10).getTime(), 221],
                                                            [new Date(2024, 1, 3 ,16,10).getTime(), 203],
                                                            [new Date(2024, 1, 3 ,17,10).getTime(), 245],
                                                            [new Date(2024, 1, 3 ,18,10).getTime(), 520],
                                                            [new Date(2024, 1, 3 ,19,10).getTime(), 233],
                                                            [new Date(2024, 1, 3 ,20,10).getTime(), 255],
                                                            [new Date(2024, 1, 3 ,21,10).getTime(), 244],
                                                            [new Date(2024, 1, 3 ,22,10).getTime(), 203],

                                                        ]
                                                    },

                                                ]}

                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default ProtalMainPage;
